<div class="edit-form">
  <mat-spinner *ngIf="uploading"></mat-spinner>
  <h3>
    {{
      'AUDIOS - ' 
      + (data.mode === 'edit' ? ('Edit Record n.' + (data.index+1)) : ('Add New Record at position ' + (data.index!+1)) )
    }}
  </h3>
  <div class="add-audio" *ngIf="data.mode==='add'" (click)="fileInput.click()">
    <div class="file-name" *ngIf="audioFileTitle!=='';else addAudio">{{audioFileTitle}}</div>
    <ng-template #addAudio>ADD AN AUDIO</ng-template>
    <input #fileInput type="file" accept=".mp3" (change)="onFileSelected($event)" style="display: none;" />
  </div>
  <div class="preview" *ngIf="data.mode==='edit'">
    <div class="file-name">{{audioFileTitle}}</div>
  </div>
  <form
      [formGroup]="editForm"
      (ngSubmit)="saveRecord()"
  >
    <input
      formControlName="title"
      placeholder="Title"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <input
      formControlName="author"
      placeholder="Author"
      type="text"
      required
      (keydown)="preventSubmit($event)"
    />
    <select formControlName="albumImgUrl" ngModel required>
      <option *ngFor="let album of albums" [value]="album.imgUrl">
        {{ album.title }}
      </option>
    </select>
    <textarea
      formControlName="description"
      placeholder="Description"
    ></textarea>
    <button type="submit">Save</button>
    <button type="button" (click)="cancel()">Cancel</button>
  </form>
</div>